import React, { Component } from 'react';
import LargeLogoColored from '../../assets/images/logo/logo-h@3x.png';
import windowSize from 'react-window-size';
import arrow from '../../assets/images/icons/down-arrow.png';
import instap from '../../assets/images/footer-icons/instagram-icn.svg';
import twitterp from '../../assets/images/footer-icons/twitter-icn-green.svg';
import { Link } from 'react-router-dom';
import md5 from 'md5';
import { baseUrl, list_id, mail_token } from '../../common/config';
import { Accordion, AccordionItem } from 'react-sanfona';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
class FooterLarge extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            isSent: false,
            emailError: '',
        };
    }
    handleChange = (e) => {
        this.setState({
            email: e.target.value,
            emailError: '',
        });
    };
    handleClick = (e) => {
        e.preventDefault();
        const subEmail = md5(this.state.email);
        fetch(`${baseUrl}/lists/${list_id}/members/${subEmail}`, {
            method: 'Put',
            headers: {
                'Authorization': `Bearer ${mail_token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email_address: this.state.email,
                status: 'subscribed',
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                console.log('Success', res);
            });
        this.setState({
            email: '',
            isSent: false,
        });
    };
    render() {
        const { t } = this.props;
        return (
            <div>
                {this.props.windowWidth > 1400 ? (
                    <div
                        className={`ace-footer-large ${
                            i18next.language === 'en' ? 'text-left' : ''
                        } ${this.props.homepage ? 'ace-footer-hp' : ''}`}
                    >
                        <hr />
                        <div className='links-row row'>
                            <div className='logo-col col'>
                                <img
                                    src={LargeLogoColored}
                                    alt='logo'
                                    className='logo'
                                />
                            </div>
                            <div className='col'>
                                <h1>{t('footer.page')}</h1>

                                <h6>
                                    <Link to='/center'>{t('nav.who')}</Link>
                                </h6>

                                <h6>
                                    <Link to='/autism'>{t('nav.autism')}</Link>
                                </h6>
                                <h6>
                                    <Link to='/blog'>{t('nav.articles')}</Link>
                                </h6>
                                <h6>
                                    <Link to='/media'>{t('nav.media')}</Link>
                                </h6>

                                <h6>
                                    <Link to='/careers'>
                                        {t('nav.careers')}
                                    </Link>
                                </h6>
                            </div>
                            <div className='col'>
                                <h1>{t('autism.title')}</h1>
                                <h6>
                                    <Link to='/autism'>
                                        {t('autism.tabs.what')}
                                    </Link>
                                </h6>
                                <h6>
                                    <Link to='/autism'>
                                        {t('autism.tabs.symptoms')}
                                    </Link>
                                </h6>
                                <h6>
                                    <Link to='/autism'>
                                        {t('autism.tabs.diagnosys')}
                                    </Link>
                                </h6>
                                <h6>
                                    <Link to='/autism'>
                                        {t('autism.tabs.reasons')}
                                    </Link>
                                </h6>
                                <h6>
                                    <Link to='/autism'>
                                        {t('autism.tabs.cure')}
                                    </Link>
                                </h6>
                            </div>
                            <div className='col'>
                                <h1>{t('nav.articles')}</h1>
                                {/* need to be change with api and functionality for 'ellipsis' */}
                                <h6 /*className='article-text'*/>
                                    <a
                                        className='footer-article-link'
                                        target='blank'
                                        href='http://138.197.73.234/uploads/autism/originals/c2b185cd-1a22-403f-b6f7-2a6fd7ddd592.pdf'
                                        rel='noopener noreferrer'
                                    >
                                        {t('footer.articles.first')}
                                    </a>
                                </h6>
                                <h6>
                                    <a
                                        className='footer-article-link'
                                        target='blank'
                                        href='http://138.197.73.234/uploads/autism/originals/f4b00fc7-c330-4e8b-b718-f3779570cae5.pdf'
                                        rel='noopener noreferrer'
                                    >
                                        {t('footer.articles.second')}
                                    </a>
                                </h6>
                                <h6>
                                    <a
                                        className='footer-article-link'
                                        target='blank'
                                        href='http://138.197.73.234/uploads/autism/originals/4acd0bba-a5fd-4a44-8823-492381da30a2.pdf'
                                        rel='noopener noreferrer'
                                    >
                                        {t('footer.articles.third')}
                                    </a>
                                </h6>
                                <h6>
                                    <a
                                        className='footer-article-link'
                                        target='blank'
                                        href='http://138.197.73.234/uploads/autism/originals/01169917-5ecb-4cb1-bd26-d05647e58d98.pdf'
                                        rel='noopener noreferrer'
                                    >
                                        {t('footer.articles.fourth')}
                                    </a>
                                </h6>
                            </div>
                            <div className='col'>
                                <h1>{t('footer.sub.title')}</h1>
                                <h6>{t('footer.sub.desc')}</h6>
                                <div
                                    className={`newsletter-input ${
                                        i18next.language === 'en'
                                            ? 'en-newsletter-input'
                                            : ''
                                    }`}
                                >
                                    <input
                                        type='email'
                                        placeholder={`${t('footer.sub.input')}`}
                                        onChange={this.handleChange}
                                        value={this.state.email}
                                    />
                                    <button
                                        className={`register-btn ${
                                            i18next.language === 'en'
                                                ? 'right'
                                                : 'left'
                                        }`}
                                        onClick={this.handleClick}
                                    >
                                        {t('homepage.connect.sub')}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='footer-bottom'>
                            <div className='row'>
                                <p>{t('footer.rights')}</p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className={`ace-footer-large ${
                            i18next.language === 'en' ? 'text-left' : ''
                        } ${this.props.homepage ? 'ace-footer-hp' : ''}`}
                    >
                        {this.props.mobile ? <></> : <hr />}
                        <div className='links-row row'>
                            {this.props.mobile ? (
                                <div></div>
                            ) : (
                                <>
                                    {this.props.windowWidth > 1000 ? (
                                        <>
                                            <Accordion className='accordion-footer'>
                                                {[
                                                    `${t('footer.page')}`,
                                                    `${t('autism.title')}`,
                                                    `${t('nav.articles')}`,
                                                ].map((item, index) => {
                                                    return (
                                                        <AccordionItem
                                                            className='accordion-footer-item'
                                                            title={`${item}`}
                                                        >
                                                            <div className='accordion-footer-links'>
                                                                {index === 0 ? (
                                                                    <>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/center'
                                                                        >
                                                                            {t(
                                                                                'nav.who'
                                                                            )}
                                                                        </Link>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/autism'
                                                                        >
                                                                            {t(
                                                                                'nav.autism'
                                                                            )}
                                                                        </Link>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/blog'
                                                                        >
                                                                            {t(
                                                                                'nav.articles'
                                                                            )}
                                                                        </Link>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/media'
                                                                        >
                                                                            {t(
                                                                                'nav.media'
                                                                            )}
                                                                        </Link>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/careers'
                                                                        >
                                                                            {t(
                                                                                'nav.careers'
                                                                            )}
                                                                        </Link>
                                                                    </>
                                                                ) : index ===
                                                                  1 ? (
                                                                    <>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/autism'
                                                                        >
                                                                            {t(
                                                                                'autism.tabs.what'
                                                                            )}
                                                                        </Link>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/autism'
                                                                        >
                                                                            {t(
                                                                                'autism.tabs.symptoms'
                                                                            )}
                                                                        </Link>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/autism'
                                                                        >
                                                                            {t(
                                                                                'autism.tabs.diagnosys'
                                                                            )}
                                                                        </Link>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/autism'
                                                                        >
                                                                            {t(
                                                                                'autism.tabs.reasons'
                                                                            )}
                                                                        </Link>
                                                                        <Link
                                                                            className='dropdown-item'
                                                                            to='/autism'
                                                                        >
                                                                            {t(
                                                                                'autism.tabs.cure'
                                                                            )}
                                                                        </Link>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <a
                                                                            className='dropdown-item footer-article-link-block'
                                                                            target='blank'
                                                                            rel='noopener noreferrer'
                                                                            href='http://138.197.73.234/uploads/autism/originals/c2b185cd-1a22-403f-b6f7-2a6fd7ddd592.pdf'
                                                                        >
                                                                            {t(
                                                                                'footer.articles.first'
                                                                            )}
                                                                        </a>
                                                                        <a
                                                                            className='dropdown-item footer-article-link-block'
                                                                            target='blank'
                                                                            rel='noopener noreferrer'
                                                                            href='http://138.197.73.234/uploads/autism/originals/f4b00fc7-c330-4e8b-b718-f3779570cae5.pdf'
                                                                        >
                                                                            {t(
                                                                                'footer.articles.second'
                                                                            )}
                                                                        </a>
                                                                        <a
                                                                            className='dropdown-item footer-article-link-block'
                                                                            target='blank'
                                                                            rel='noopener noreferrer'
                                                                            href='http://138.197.73.234/uploads/autism/originals/4acd0bba-a5fd-4a44-8823-492381da30a2.pdf'
                                                                        >
                                                                            {t(
                                                                                'footer.articles.third'
                                                                            )}
                                                                        </a>
                                                                        <a
                                                                            className='dropdown-item footer-article-link-block'
                                                                            target='blank'
                                                                            rel='noopener noreferrer'
                                                                            href='http://138.197.73.234/uploads/autism/originals/01169917-5ecb-4cb1-bd26-d05647e58d98.pdf'
                                                                        >
                                                                            {t(
                                                                                'footer.articles.fourth'
                                                                            )}
                                                                        </a>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </AccordionItem>
                                                    );
                                                })}
                                            </Accordion>
                                            {/* <div className='col'>
                                                <div className='dropdown'>
                                                    <button
                                                        className='btn register-btn dropdown-toggle'
                                                        type='button'
                                                        id='dropdownMenuButton'
                                                        data-toggle='dropdown'
                                                        aria-haspopup='true'
                                                        aria-expanded='false'
                                                    >
                                                        {t('footer.page')}
                                                        <img
                                                            src={arrow}
                                                            alt='arrow'
                                                            className='toggler-icon'
                                                        ></img>
                                                    </button>
                                                    <div
                                                        className='dropdown-menu'
                                                        aria-labelledby='dropdownMenuButton'
                                                    >
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/center'
                                                        >
                                                            {t('nav.who')}
                                                        </Link>
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/autism'
                                                        >
                                                            {t('nav.autism')}
                                                        </Link>
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/blog'
                                                        >
                                                            {t('nav.articles')}
                                                        </Link>
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/media'
                                                        >
                                                            {t('nav.media')}
                                                        </Link>
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/careers'
                                                        >
                                                            {t('nav.careers')}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col'>
                                                <div className='dropdown'>
                                                    <button
                                                        className='btn register-btn dropdown-toggle'
                                                        type='button'
                                                        id='dropdownMenuButton'
                                                        data-toggle='dropdown'
                                                        aria-haspopup='true'
                                                        aria-expanded='false'
                                                    >
                                                        {t('autism.title')}
                                                        <img
                                                            src={arrow}
                                                            alt='arrow'
                                                            className='toggler-icon'
                                                        ></img>
                                                    </button>
                                                    <div
                                                        className='dropdown-menu'
                                                        aria-labelledby='dropdownMenuButton'
                                                    >
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/autism'
                                                        >
                                                            {t(
                                                                'autism.tabs.what'
                                                            )}
                                                        </Link>
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/autism'
                                                        >
                                                            {t(
                                                                'autism.tabs.symptoms'
                                                            )}
                                                        </Link>
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/autism'
                                                        >
                                                            {t(
                                                                'autism.tabs.diagnosys'
                                                            )}
                                                        </Link>
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/autism'
                                                        >
                                                            {t(
                                                                'autism.tabs.reasons'
                                                            )}
                                                        </Link>
                                                        <Link
                                                            className='dropdown-item'
                                                            to='/autism'
                                                        >
                                                            {t(
                                                                'autism.tabs.cure'
                                                            )}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col'>
                                                <div className='dropdown'>
                                                    <button
                                                        className='btn register-btn dropdown-toggle'
                                                        type='button'
                                                        id='dropdownMenuButton'
                                                        data-toggle='dropdown'
                                                        aria-haspopup='true'
                                                        aria-expanded='false'
                                                    >
                                                        {t('nav.articles')}
                                                        <img
                                                            src={arrow}
                                                            alt='arrow'
                                                            className='toggler-icon'
                                                        ></img>
                                                    </button>
                                                    <div
                                                        className='dropdown-menu'
                                                        aria-labelledby='dropdownMenuButton'
                                                    >
                                                        <a
                                                            className='dropdown-item footer-article-link-block'
                                                            target='blank'
                                                            rel='noopener noreferrer'
                                                            href='http://138.197.73.234/uploads/autism/originals/c2b185cd-1a22-403f-b6f7-2a6fd7ddd592.pdf'
                                                        >
                                                            {t(
                                                                'footer.articles.first'
                                                            )}
                                                        </a>
                                                        <a
                                                            className='dropdown-item footer-article-link-block'
                                                            target='blank'
                                                            rel='noopener noreferrer'
                                                            href='http://138.197.73.234/uploads/autism/originals/f4b00fc7-c330-4e8b-b718-f3779570cae5.pdf'
                                                        >
                                                            {t(
                                                                'footer.articles.second'
                                                            )}
                                                        </a>
                                                        <a
                                                            className='dropdown-item footer-article-link-block'
                                                            target='blank'
                                                            rel='noopener noreferrer'
                                                            href='http://138.197.73.234/uploads/autism/originals/4acd0bba-a5fd-4a44-8823-492381da30a2.pdf'
                                                        >
                                                            {t(
                                                                'footer.articles.third'
                                                            )}
                                                        </a>
                                                        <a
                                                            className='dropdown-item footer-article-link-block'
                                                            target='blank'
                                                            rel='noopener noreferrer'
                                                            href='http://138.197.73.234/uploads/autism/originals/01169917-5ecb-4cb1-bd26-d05647e58d98.pdf'
                                                        >
                                                            {t(
                                                                'footer.articles.fourth'
                                                            )}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className='row'>
                                                <div className='newsletter-container'>
                                                    <h1>
                                                        {t('footer.sub.title')}
                                                    </h1>
                                                    <h6>
                                                        {t('footer.sub.desc')}
                                                    </h6>
                                                    <div
                                                        className={`newsletter-input ${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'en-newsletter-input'
                                                                : ''
                                                        }`}
                                                    >
                                                        <input
                                                            type='email'
                                                            placeholder={`${t(
                                                                'footer.sub.input'
                                                            )}`}
                                                            onChange={
                                                                this
                                                                    .handleChange
                                                            }
                                                            value={
                                                                this.state.email
                                                            }
                                                        />
                                                        <button
                                                            className={`register-btn ${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'right'
                                                                    : 'left'
                                                            }`}
                                                            onClick={
                                                                this.handleClick
                                                            }
                                                        >
                                                            {t(
                                                                'homepage.connect.sub'
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                        <Accordion className='accordion-footer'>
                                            {[
                                                `${t('footer.page')}`,
                                                `${t('autism.title')}`,
                                                `${t('nav.articles')}`,
                                            ].map((item, index) => {
                                                return (
                                                    <AccordionItem
                                                        className='accordion-footer-item'
                                                        title={`${item}`}
                                                    >
                                                        <div className='accordion-footer-links'>
                                                            {index === 0 ? (
                                                                <>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/center'
                                                                    >
                                                                        {t(
                                                                            'nav.who'
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/autism'
                                                                    >
                                                                        {t(
                                                                            'nav.autism'
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/blog'
                                                                    >
                                                                        {t(
                                                                            'nav.articles'
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/media'
                                                                    >
                                                                        {t(
                                                                            'nav.media'
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/careers'
                                                                    >
                                                                        {t(
                                                                            'nav.careers'
                                                                        )}
                                                                    </Link>
                                                                </>
                                                            ) : index === 1 ? (
                                                                <>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/autism'
                                                                    >
                                                                        {t(
                                                                            'autism.tabs.what'
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/autism'
                                                                    >
                                                                        {t(
                                                                            'autism.tabs.symptoms'
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/autism'
                                                                    >
                                                                        {t(
                                                                            'autism.tabs.diagnosys'
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/autism'
                                                                    >
                                                                        {t(
                                                                            'autism.tabs.reasons'
                                                                        )}
                                                                    </Link>
                                                                    <Link
                                                                        className='dropdown-item'
                                                                        to='/autism'
                                                                    >
                                                                        {t(
                                                                            'autism.tabs.cure'
                                                                        )}
                                                                    </Link>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <a
                                                                        className='dropdown-item footer-article-link-block'
                                                                        target='blank'
                                                                        rel='noopener noreferrer'
                                                                        href='http://138.197.73.234/uploads/autism/originals/c2b185cd-1a22-403f-b6f7-2a6fd7ddd592.pdf'
                                                                    >
                                                                        {t(
                                                                            'footer.articles.first'
                                                                        )}
                                                                    </a>
                                                                    <a
                                                                        className='dropdown-item footer-article-link-block'
                                                                        target='blank'
                                                                        rel='noopener noreferrer'
                                                                        href='http://138.197.73.234/uploads/autism/originals/f4b00fc7-c330-4e8b-b718-f3779570cae5.pdf'
                                                                    >
                                                                        {t(
                                                                            'footer.articles.second'
                                                                        )}
                                                                    </a>
                                                                    <a
                                                                        className='dropdown-item footer-article-link-block'
                                                                        target='blank'
                                                                        rel='noopener noreferrer'
                                                                        href='http://138.197.73.234/uploads/autism/originals/4acd0bba-a5fd-4a44-8823-492381da30a2.pdf'
                                                                    >
                                                                        {t(
                                                                            'footer.articles.third'
                                                                        )}
                                                                    </a>
                                                                    <a
                                                                        className='dropdown-item footer-article-link-block'
                                                                        target='blank'
                                                                        rel='noopener noreferrer'
                                                                        href='http://138.197.73.234/uploads/autism/originals/01169917-5ecb-4cb1-bd26-d05647e58d98.pdf'
                                                                    >
                                                                        {t(
                                                                            'footer.articles.fourth'
                                                                        )}
                                                                    </a>
                                                                </>
                                                            )}
                                                        </div>
                                                    </AccordionItem>
                                                );
                                            })}
                                        </Accordion>
                                        <div className='row py-5'>
                                                <div className='newsletter-container'>
                                                    <h1>
                                                        {t('footer.sub.title')}
                                                    </h1>
                                                    <h6>
                                                        {t('footer.sub.desc')}
                                                    </h6>
                                                    <div
                                                        className={`newsletter-input ${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'en-newsletter-input'
                                                                : ''
                                                        }`}
                                                    >
                                                        <input
                                                            type='email'
                                                            placeholder={`${t(
                                                                'footer.sub.input'
                                                            )}`}
                                                            onChange={
                                                                this
                                                                    .handleChange
                                                            }
                                                            value={
                                                                this.state.email
                                                            }
                                                        />
                                                        <button
                                                            className={`register-btn ${
                                                                i18next.language ===
                                                                'en'
                                                                    ? 'right'
                                                                    : 'left'
                                                            }`}
                                                            onClick={
                                                                this.handleClick
                                                            }
                                                        >
                                                            {t(
                                                                'homepage.connect.sub'
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            </>
                                      
                                    )}
                                </>
                            )}
                        </div>
                        <>
                            {this.props.minimal ? (
                                <>
                                    {this.props.white ? (
                                        <div className='mobile footer-mobile-white'>
                                            <div className='footer-bottom'>
                                                <div className='row'>
                                                    <p>{t('footer.rights')} </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='mobile '>
                                            <div className='col'>
                                                <div className='row'>
                                                    <a
                                                        href='https://twitter.com/acesaudiorg'
                                                        target='_blank'
                                                        rel='noopener noreferrer'
                                                    >
                                                        <img
                                                            src={twitterp}
                                                            alt='twitter'
                                                            className='social-icon'
                                                        />
                                                    </a>
                                                    <a
                                                        href='https://www.instagram.com/acesaudiorg'
                                                        target='_blank'
                                                        rel='noopener noreferrer'
                                                    >
                                                        <img
                                                            src={instap}
                                                            alt='instagram'
                                                            className='social-icon'
                                                        />
                                                    </a>
                                                </div>
                                                <p className='rights'>
                                                    {t('footer.rights')}
                                                </p>
                                            </div>
                                            <div className='footer-bottom'></div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className='footer-bottom'>
                                    <div className='row'>
                                        <div className='col'>
                                            <p>{t('footer.rights')}</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    </div>
                )}
            </div>
        );
    }
}

export default withTranslation()(windowSize(FooterLarge));
